import { Dispatch } from '../../types'
import { fetchEnvironments, selectEnvironmentForEnvironments } from '../environment/actions'
import { fetchAllResources, selectAnypointResource } from '../resource/actions'
import { isAsset, Resource } from '../resource/model'
import { fetchVersions, selectVersion } from '../version/actions'
import { API, Asset, Environment } from '../../remote-api/models'
import { SelectorOptions } from './model'
import { ResourceNotFoundError } from '../error/ResourceNotFoundError'

// Thunks

export const fetchMainSelectorsOptionsAndSelect = (options: SelectorOptions, envId?: string, resourceId?: string,
                                                   versionId?: string, skipFetchingResources?: boolean) =>
  (dispatch: Dispatch): Promise<void> => {
    return dispatch<Promise<Environment[]>>(fetchEnvironments(options.origin)).then(environments => {
      if (skipFetchingResources) {
        return Promise.resolve();
      }
      const maybeEnvironment: Environment | undefined = dispatch(selectEnvironmentForEnvironments(options, environments, envId))
      if (!maybeEnvironment) {
        throw new ResourceNotFoundError(`Environment not found. envId:${envId}`)
      }
      return dispatch(fetchAllResourcesAndVersions({...options, shouldSelect: true}, maybeEnvironment, resourceId, versionId))
    })
  }

export const fetchAllResourcesAndVersions = (options: SelectorOptions,
                                             environment: Environment,
                                             resourceId?: string,
                                             versionId?: string) => (dispatch: Dispatch) => {
  if (options.shouldSelect) {
    return dispatch<Promise<Resource[]>>(fetchAllResources(options, environment.id)).then(resources => {
      const maybeResource: Resource | undefined = dispatch(selectAnypointResource(options, resources, resourceId, versionId))
      if (maybeResource && isAsset(maybeResource)) {
        return dispatch(fetchVersionsAndSelect(options, maybeResource, versionId))
      } else {
        dispatch(selectVersion(options, [], undefined))
      }
      return Promise.resolve()
    })
  } else {
    dispatch(selectAnypointResource(options, [], undefined))
    dispatch(selectVersion(options, [], undefined))

    return dispatch<Promise<Resource[]>>(fetchAllResources(options, environment.id)).then(() => {
      return Promise.resolve()
    })
  }
}

export const fetchVersionsAndSelect = (options: SelectorOptions, asset: Asset, versionId?: string) =>
  (dispatch: Dispatch) => {
    return dispatch<Promise<API[]>>(fetchVersions(asset, options.origin)).then(versions => {
      dispatch(selectVersion(options, versions, versionId))
    })
  }

export const selectEnvironmentAndFetchAllResources = (options: SelectorOptions, envId: string, environments?: Environment[]) =>
  (dispatch: Dispatch) => {
    if (environments) {
      const maybeEnvironment = dispatch<Environment | undefined>(selectEnvironmentForEnvironments(options, environments, envId))
      if (maybeEnvironment) {
        return dispatch(fetchAllResourcesAndVersions(options, maybeEnvironment, undefined, undefined))
      }
      return Promise.resolve()
    }
    return Promise.resolve()
  }

export const selectResourceAndFetchVersions = (options: SelectorOptions, resourceId: string, resources?: Resource[]) =>
  (dispatch: Dispatch) => {
    if (resources) {
      const maybeResource = dispatch<Resource | undefined>(selectAnypointResource(options, resources, resourceId))
      if (maybeResource && isAsset(maybeResource)) {
        dispatch(fetchVersionsAndSelect(options, maybeResource, undefined))
      }
    }
  }
